import { Globe, ShieldAlert } from "lucide-react";
import { AddressChip, Panel } from "../trace/Primitives";
import { fmtNum } from "../../lib/trace";

export const OverviewCard = ({ data }) => {
  const t = data.token;
  return (
    <Panel eyebrow="Token overview" title={<span data-testid="token-name">{t.name} <span className="text-trace-dim">· {t.symbol}</span></span>}
      testId="dashboard-overview-card" className="lg:col-span-2"
      right={t.image ? <img src={t.image} alt={`${t.symbol} logo`} className="h-12 w-12 rounded-lg border border-trace-line object-cover" /> : null}>
      <dl className="grid grid-cols-2 gap-x-6 gap-y-4 text-sm sm:grid-cols-4">
        <div className="col-span-2"><dt className="eyebrow">Mint address</dt><dd className="mt-1.5"><AddressChip address={t.address} chars={8} link={!data.is_demo} kind="token" testId="token-mint-address" /></dd></div>
        <div><dt className="eyebrow">Program</dt><dd className="mt-1.5 text-white" data-testid="token-program">{t.program}</dd></div>
        <div><dt className="eyebrow">Decimals</dt><dd className="mt-1.5 font-mono text-white">{t.decimals}</dd></div>
        <div><dt className="eyebrow">Total supply</dt><dd className="mt-1.5 font-mono text-white" data-testid="token-supply">{fmtNum(t.supply_ui)}</dd></div>
        <div><dt className="eyebrow">Holders</dt><dd className="mt-1.5 font-mono text-white" data-testid="token-holders-count">{fmtNum(data.holders.total_holders)}</dd></div>
        <div className="col-span-2"><dt className="eyebrow">Links (self-reported)</dt>
          <dd className="mt-1.5 flex flex-wrap gap-2">
            {[...t.websites.map((u) => ({ type: "website", url: u })), ...t.socials].map((l) => (
              <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1 rounded-md border border-trace-line px-2 py-0.5 text-xs capitalize text-trace-muted hover:text-white">
                <Globe size={11} /> {l.type}
              </a>
            ))}
            {!t.websites.length && !t.socials.length && <span className="text-trace-dim">None listed</span>}
          </dd>
        </div>
      </dl>
    </Panel>
  );
};

export const RiskSummary = ({ data }) => {
  const s = data.risk_summary;
  const level = s.high ? ["Elevated", "text-red-400"] : s.medium ? ["Moderate", "text-amber-300"] : ["Few signals", "text-trace-green"];
  return (
    <Panel eyebrow="Signal summary" title="Risk indicators" icon={ShieldAlert} testId="risk-summary-card">
      <p className={`font-heading text-3xl font-semibold tracking-tight ${level[1]}`} data-testid="risk-score-badge">{level[0]}</p>
      <p className="mt-1 text-xs text-trace-dim">Signal level · not a safety rating</p>
      <div className="mt-5 grid grid-cols-3 gap-2 text-center">
        {[["high", s.high, "text-red-400"], ["medium", s.medium, "text-amber-300"], ["low", s.low, "text-sky-300"]].map(([k, v, c]) => (
          <div key={k} className="rounded-lg border border-trace-line bg-trace-panel py-3" data-testid={`risk-count-${k}`}>
            <p className={`font-heading text-xl ${c}`}>{v}</p>
            <p className="eyebrow mt-0.5">{k}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs leading-relaxed text-trace-muted">
        {s.high + s.medium + s.low} of {s.checks_run} checks flagged. No score or indicator can guarantee that a token is safe.
      </p>
    </Panel>
  );
};
